import ZkCheckbox from './src/checkbox';

/* istanbul ignore next */
ZkCheckbox.install = function(Vue) {
  Vue.component(ZkCheckbox.name, ZkCheckbox);
};

export default ZkCheckbox;




// WEBPACK FOOTER //
// ./src/packages/checkbox/index.js